import { render } from "./index.vue?vue&type=template&id=dffe9470"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "@/index.scss?vue&type=style&index=0&lang=scss"
import "./index.vue?vue&type=style&index=1&id=dffe9470&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__